import React from 'react';
import {
  BetNotificationWr,
  SlowConnectionWr,
  ConnectionPopupsWr,
  UnderMaintenanceWr,
} from '@pascal/pascal-core';
import { Game } from '../../common/game';
import {
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
  AdditionalResponseCode,
} from '../../../enums/additionalNotifications';

export const WebGame = () => {
  return (
    <>
      <Game />
      <BetNotificationWr
        AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
        AdditionalResponseCode={AdditionalResponseCode}
        AdditionalErrorMessages={AdditionalErrorMessages}
      />
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <ConnectionPopupsWr />
    </>
  );
};
